export default "__VITE_ASSET__CLHrdKK0__"